module.exports = "/static/assets/25365a729d97c1ef1cdd81e120e0fbf3.png";